<template>
  <div>
    <vue-friendly-iframe :src="'https://wernicke-foto.de/marzipano/Fotostudio/'"></vue-friendly-iframe>
  </div>
</template>

<script>
  export default {
    name: "Studio",
   
  }
</script>

<style>
  .iframe {
    /*height: 100%;*/
  }
  .vue-friendly-iframe iframe {
    width: 99vw;
    height: 76.5vh;
  }

</style>